/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSurveyQuestions } from 'app/entities/survey-question/survey-question.reducer';
import { getEntities as getSurveyOptionChoices } from 'app/entities/survey-option-choice/survey-option-choice.reducer';
import { createEntity, getEntity, reset, updateEntity } from './survey-question-option.reducer';

export const SurveyQuestionOptionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const surveyQuestions = useAppSelector(state => state.surveyQuestion.entities);
  const surveyOptionChoices = useAppSelector(state => state.surveyOptionChoice.entities);
  const surveyQuestionOptionEntity = useAppSelector(state => state.surveyQuestionOption.entity);
  const loading = useAppSelector(state => state.surveyQuestionOption.loading);
  const updating = useAppSelector(state => state.surveyQuestionOption.updating);
  const updateSuccess = useAppSelector(state => state.surveyQuestionOption.updateSuccess);

  const handleClose = () => {
    navigate(`/survey-question-option${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSurveyQuestions({}));
    dispatch(getSurveyOptionChoices({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.weightage !== undefined && typeof values.weightage !== 'number') {
      values.weightage = Number(values.weightage);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...surveyQuestionOptionEntity,
      ...values,
      question: surveyQuestions.find(it => it.id.toString() === values.question?.toString()),
      optionChoice: surveyOptionChoices.find(it => it.id.toString() === values.optionChoice?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...surveyQuestionOptionEntity,
          question: surveyQuestionOptionEntity?.question?.id,
          optionChoice: surveyQuestionOptionEntity?.optionChoice?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.surveyQuestionOption.home.createOrEditLabel" data-cy="SurveyQuestionOptionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.home.createOrEditLabel">
              Create or edit a SurveyQuestionOption
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="survey-question-option-id"
                  label={translate('tinyMedicRestApp.surveyQuestionOption.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestionOption.weightage')}
                id="survey-question-option-weightage"
                name="weightage"
                data-cy="weightage"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestionOption.active')}
                id="survey-question-option-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestionOption.cursor')}
                id="survey-question-option-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestionOption.lastupdated')}
                id="survey-question-option-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestionOption.microSec')}
                id="survey-question-option-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestionOption.timestampentry')}
                id="survey-question-option-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="survey-question-option-question"
                name="question"
                data-cy="question"
                label={translate('tinyMedicRestApp.surveyQuestionOption.question')}
                type="select"
                required
              >
                <option value="" key="0" />
                {surveyQuestions
                  ? surveyQuestions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="survey-question-option-optionChoice"
                name="optionChoice"
                data-cy="optionChoice"
                label={translate('tinyMedicRestApp.surveyQuestionOption.optionChoice')}
                type="select"
                required
              >
                <option value="" key="0" />
                {surveyOptionChoices
                  ? surveyOptionChoices.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/survey-question-option" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SurveyQuestionOptionUpdate;
